import script from "./NotificationGlobal.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationGlobal.vue?vue&type=script&setup=true&lang=js"

import "./NotificationGlobal.vue?vue&type=style&index=0&id=8ba4352c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ba4352c"]])

export default __exports__